export const toFormattedAmount = (amount: string, decimalsLimit?: number) => {
  const addSeparators = (value: string, separator = ',') => value.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  const unformattedValue = cleanAmount(amount);
  if (decimalSeparator && unformattedValue.includes(decimalSeparator)) {
    const [int, decimals] = unformattedValue.split(decimalSeparator);
    const trimmedDecimals = decimalsLimit && decimals ? decimals.slice(0, decimalsLimit) : decimals;
    const includeDecimals = decimalsLimit && decimalsLimit > 0 ? `${decimalSeparator}${trimmedDecimals}` : '';
    const formattedInt = addSeparators(int);
    return `${formattedInt}${includeDecimals}`;
  }
  return addSeparators(unformattedValue);
};

export const toFormattedFixedDecimalAmount = (amount: string, decimalsLimit: number = 0) => {
  const isWholeNumber = (value: string) => value.indexOf(decimalSeparator) == -1;
  const rawValue = toNumericAmount(amount).toFixed(isWholeNumber(amount) ? 0 : decimalsLimit);
  return toFormattedAmount(rawValue, decimalsLimit);
};

export const toNumericAmount = (formattedAmount: string) => {
  const unformattedValue = cleanAmount(formattedAmount);
  return unformattedValue ? parseFloat(unformattedValue) : 0;
};

const decimalSeparator = '.';

const cleanAmount = (value: string) => {
  return value.replace(/[^0-9.]/g, '');
};
